import { MailOutlined } from '@ant-design/icons';
import { PaidOnlyTag } from '@components';
import { isDemoTenant, L } from '@lib';
import { Grid, Space, Tooltip } from 'antd';
import React from 'react';
import { SuccessButton } from './SuccessButton';

const { useBreakpoint } = Grid;

interface EmailButtonProps {
  onClick: (e: React.MouseEvent) => void;
  tooltip?: string;
  size?: 'small' | 'middle' | 'large';
  iconOnly?: boolean;
  showText?: boolean;
  block?: boolean;
}

export const EmailButton: React.FC<EmailButtonProps> = ({
  onClick,
  tooltip = 'Send email',
  size,
  iconOnly = false,
  showText,
  block = false,
}) => {
  const screens = useBreakpoint();
  const shouldShowText = showText ?? (!iconOnly && screens.md);

  // Every use of this button sends mail, which a trial cannot do, so the marking lives
  // here rather than being repeated at each call site. In table rows the button is
  // icon-only and a tag will not fit, so the tooltip carries it instead.
  const isDemo = isDemoTenant();

  return (
    <Tooltip title={isDemo ? 'Paid only — sending email needs the full account' : tooltip}>
      <SuccessButton size={size} icon={<MailOutlined />} onClick={onClick} block={block}>
        {shouldShowText &&
          (isDemo ? (
            <Space size={8}>
              {L('Send email')}
              <PaidOnlyTag />
            </Space>
          ) : (
            L('Send email')
          ))}
      </SuccessButton>
    </Tooltip>
  );
};
